// extracted by extract-css-chunks-webpack-plugin
module.exports = {"home_news_tag_page":"HomeNewsTagPage__home_news_tag_page--3rJro","tag":"HomeNewsTagPage__tag--1V7c6","nav":"HomeNewsTagPage__nav--LDiOf"};